<!--
 * @Author: LiZhiWei
 * @Date: 2026-06-02 08:54:03
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-06-02 14:10:34
 * @Description: 
-->
<template>
  <section
    id="scenarios"
    ref="scenariosSection"
    class="landing-container lt-sm:px-32px scroll-mt-70px bg-#f1f7ff py-112px lt-sm:py-120px transition-all duration-1000 ease-out"
    :class="[isScenariosVisible ? 'translate-y-0 opacity-100' : 'translate-y-50px opacity-0']"
    data-section
  >
    <section-heading
      title="高频服务，看得见、跟得上"
      description="全面覆盖高频业务场景，服务进度实时可视，团队响应动态追踪。"
    />

    <div class="gap-14px lt-sm:grid-cols-2 lt-sm:gap-25px grid grid-cols-7">
      <article
        v-for="item in scenarios"
        :key="item.title"
        class="min-h-206px rounded-16px border-#e2e8f0 p-24px hover:-translate-y-4px hover:border-#bfd6ff lt-sm:min-h-300px lt-sm:p-24px border bg-white transition-all duration-220 hover:shadow-[0_16px_40px_rgba(15,23,42,0.06)]"
      >
        <i
          class="mb-16px h-40px w-40px lt-sm:h-64px lt-sm:w-64px object-contain"
          :class="item.icon"
        ></i>
        <h3
          class="pf-sc-semibold mb-12px font-s-18px text-#0f172a lt-sm:font-s-28px lt-sm:leading-[40px] m-0 leading-[1.35]"
        >
          {{ item.title }}
        </h3>
        <p
          class="pf-sc-regular font-s-15px text-#64748b lt-sm:font-s-24px lt-sm:leading-[36px] m-0 leading-[1.7] break-words"
        >
          {{ item.text }}
        </p>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
  import SectionHeading from '../section-heading.vue'

  import { scenarios } from '~/constants/huiguanjia-home'

  defineOptions({
    name: 'ScenariosSection',
  })

  const scenariosSection = useTemplateRef<HTMLElement>('scenariosSection')
  const { isVisible: isScenariosVisible } = useScrollReveal(scenariosSection)
</script>
